<template>

  <md-dialog :md-active.sync="showEditSSCCDialog" v-on:md-clicked-outside="onCancelEditRow()">
    <md-dialog-title v-show="editSSCData.id !== 0">Modifica</md-dialog-title>
    <md-dialog-title v-show="editSSCData.id === 0">Nuovo</md-dialog-title>
    <md-dialog-content>
      <md-vuelidated>
        <label for="pos">No.</label>
        <md-input type="text" v-model="number" />
        <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
      </md-vuelidated>
      <md-vuelidated>
        <label for="row">Pallet</label>
        <md-input type="text" v-model="pallet" />
        <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
      </md-vuelidated>
      <md-switch v-model="rotto">Rotto</md-switch>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button class="md-primary md-raised" @click="onConfirmEditRow()">Conferma</md-button>
      <md-button class="md-primary" @click="onCancelEditRow()">Annulla</md-button>
    </md-dialog-actions>
  </md-dialog>

</template>
<script>

  import { validationMixin } from 'vuelidate'
  import { required, minLength, maxLength } from 'vuelidate/lib/validators'

  export default {
    name: 'CaricoSSCCEdit',
    mixins: [validationMixin],
    props: ['showEditSSCCDialog', 'editSSCData'],
    validations: {
      number: {
        required
      },
      pallet: {
        required
      }
    },
    computed: {
      rowId: {
        get() {
          return this.editSSCData.rowId
        },
        set(val) {
          this.editSSCData.rowId = val
        }
      },
      number: {
        get() {
          return this.editSSCData.number
        },
        set(val) {
          this.editSSCData.number = val
        }
      },
      pallet: {
        get() {
          return this.editSSCData.pallet
        },
        set(val) {
          this.editSSCData.pallet = val
        }
      },
      rotto: {
        get() {
          return this.editSSCData.rotto
        },
        set(val) {
          this.editSSCData.rotto = val
        }
      }
    },
    methods: {
      onConfirmEditRow() {
        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        }
        var values = {
          id: this.editSSCData.id,
          number: this.number,
          pallet: this.pallet,
          rotto: this.rotto,
          rowId: this.rowId
        }
        this.$v.$reset()
        this.$emit('save-sscc-row', values)
      },
      onCancelEditRow() {
        this.$v.$reset()
        this.$emit('close-sscc-edit')
      }
    }
  }

</script>

<style>

  x.md-field .md-error {
    display: block !important;
    left: 0;
    opacity: 0;
    transform: translate3d(0, -8px, 0);
  }
  .md-field .md-count,
  .md-field .md-error,
  .md-field .md-helper-text {
    height: 20px;
    position: absolute;
    bottom: -22px;
    font-size: 12px;
    transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .md-field.md-invalid .md-error {
    opacity: 1;
    transform: translateZ(0);
  }
  .md-invalid .md-error,
  .md-invalid label {
    color: #ff1744;
  }
  .field-wrapper {
    display: flex;
    max-width: 220px;
    width: 100%;
    justify-content: space-between;
  }
  .field-wrapper > .md-field:first-child {
    max-width: 65%;
  }
  .field-wrapper > .md-field:last-child {
    max-width: 25%;
  }

</style>



// WEBPACK FOOTER //
// src/components/CaricoSSCCEdit.vue